import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.container = {
    css: css`
        h1 {
            color: #3666b1;
        }
    `,
};

orderConfirmationPageContainerStyles.productListGridItem = {
    css: css`
        order: 4;
        [data-test-selector^="cardLinesList"] {
            background: #fafafa;
            > div[class^="sc"] {
                background: #ffffff;
                [data-id="checkbox"] {
                    visibility: hidden;
                }
            }
            [data-test-selector="heading"] {
                font-weight: normal;
                color: rgb(71, 71, 71);
                font-size: 12px;
            }
            legend {
                font-weight: normal;
                color: rgb(71, 71, 71);
                font-size: 12px;
            }
            [data-test-selector="productPrice_unitNetPrice"] {
                color: #3666b1;
                font-weight: bold;
            }

            [data-test-selector="sectionHeader"] {
                border: 1px solid #cccccc;
            }
            [data-test-selector="productPrice_unitOfMeasureLabel"] {
                color: #3666b1;
                font-weight: bold;
            }
            [data-test-selector="productImage"] {
                height: 150px;
            }
            [class^="StyledImg"] {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: center top;
            }
            [data-test-selector="productDescriptionLink"] {
                span {
                    color: rgb(15, 15, 15);
                    font-weight: 700;
                }
            }
            div[class^="GridWrapper"] {
                div[class^="GridItemStyle"]:nth-child(2) {
                    [data-test-selector="text"] {
                        font-weight: normal;
                        color: rgb(15, 15, 15);
                    }
                }
            }
            div[class^="GridWrapper"] {
                div[class^="GridItemStyle"]:nth-child(3) {
                    [data-test-selector="text"] {
                        color: #3666b1;
                        font-weight: bold;
                    }
                }
            }
            section[class^="sc"] {
                > div {
                    align-items: center;
                    justify-content: flex-start;
                    > legend {
                        padding-top: 2px;
                    }
                }
            }
        }
    `,
    width: [12, 12, 12, 8, 8],
};
